import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {loginMaestraComponent} from "./loginMaestra.component";
import {LoginService} from "./login.service";
import {verificarUsuariomaestraComponent} from "./verificar-usuarioMaestra.component";
import {cambiarContrasenaComponent} from "./cambiar-contrasena.component";
import {nuevaContrasenaComponent} from "./nueva-contrasena.component";
import { ShowHideInput, ShowHideInput2, ShowHideInput3 } from "./show-hide-input.directive"; 
import { RouterModule } from "@angular/router";
import { Ng2Bs3ModalModule } from "../../../../node_modules/ng2-bs3-modal/ng2-bs3-modal";

@NgModule({
    declarations: [loginMaestraComponent, verificarUsuariomaestraComponent],
    imports     : [BrowserModule,HttpModule,FormsModule,RouterModule,Ng2Bs3ModalModule],
    providers : [LoginService]
})

export class LoginMaestraModule {}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/login/loginMaestra.module.ts